import { defineComponent as _defineComponent } from 'vue'
import ElementTreeBlockButton from '@/components/FlowTree/FlowTreeBlock/ElementTreeBlockButton/ElementTreeBlockButton.vue';
import { AddOnTile } from './types';
import { WorkflowsKey } from '../types';
import { useInject } from '@/components/SideBar/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddOnTileItem',
  props: {
    tile: null
  },
  setup(__props: any) {

const props = __props as { tile: AddOnTile }


const { runWorkflow } = useInject(WorkflowsKey);
const onClick = () => {
	runWorkflow(props.tile.id);
};

return { __sfc: true,props, runWorkflow, onClick, ElementTreeBlockButton }
}

})